import Vue from 'vue';
import store from '../store/index.js';
import ProductDetailsComponent from '../components/product-list/product-details-component.vue';
import { getStaticProductDetailsModel } from '../utils/product-details-model-builder.js';

const productDetails = DM.Boot.ProductDetails;

const Selectors = {
    CONTAINER: '.js-product-details'
};

const ProductDetails = (() => {

    class ProductDetails {

        constructor(element) {
            this.vm = this.createComponent(element);
        }

        createComponent(el) {
            const model = productDetails ? getStaticProductDetailsModel(productDetails) : null;

            return new Vue({
                render: h => h(ProductDetailsComponent, { props: { ...model } }),
                el,
                store
            });
        }
    }

    [].map.call(document.querySelectorAll(Selectors.CONTAINER), (item) => {
        return new ProductDetails(item);
    });

})();

export default ProductDetails;
